import axios from "../../axios-config";

const handleError = (toast, error) => {
    const message = error.response?.data?.message || error.message;
    const status = error.response?.status;

    if ([400, 401, 403, 500].includes(status)) {
        toast.error(message, {
            position: "top-center",
            theme: "colored",
            hideProgressBar: true,
        });
    } else {
        toast.error(message, {
            position: "top-center",
            theme: "colored",
            hideProgressBar: true,
        });
    }
};

export const sendSupportMessage = (toast, body, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        try {
            const response = await axios.post('/contact/v1/send-message', body);
            toast.success(response.data.message, {
                position: "top-center",
                theme: "colored",
                hideProgressBar: true
            });
        } catch (error) {
            handleError(toast, error);
        } finally {
            setIsLoading(false)
        }
    };
};